import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { NoticeDetailItem } from '~/features/notices/types/notices.type';

/**
 * 공지사항/FAQ 상세 조회
 * @endpoint GET /notices/:id
 */
export function getNoticeDetailApi(id: number) {
  return axiosInstance.get<ApiResponse<NoticeDetailItem>>(`/notices/${id}`);
}
